import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import DAY_ZONE_TYPES from 'constants/DAY_ZONE_TYPES';
import HBox from 'components/common/HBox';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function ExerciseDialogBloodSugarTable(props) {
  const {
    data,
    ...rest
  } = props;

  const {
    bldsugr_graph_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    step_cnt_graph_list = [],
    // active_time,
    // step_cnt,
    daily_step_cnt,
    daily_step_time,
    postprand2h_step_cnt,
    postprand2h_step_time,
    daily_burn_cal,
    postprand2h_burn_cal,
    max_bldsugr_val,
    max_bldsugr_time,
    max_bldsugr_tmzone_cd,
    min_bldsugr_val,
    min_bldsugr_time,
    min_bldsugr_tmzone_cd,
    max_bldsugr_rise_w,
    avg_bldsugr,
    postprand2h_bldsugr_val,
    total_abnormal_cnt,
    total_high_cnt,
    total_low_cnt,
    avg_intaken_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    total_insulin_amt,
    total_bolus_amt,
    total_giju_amt,
    bolus_inject_list = [],
    // bolus_inject_time,
    // bolus_inject_amt,
  } = data;

  const max_time = React.useMemo(() => {
    const time = (max_bldsugr_time || '').split('');
    time.splice(2, 0, ':');
    return time.join('');
  }, [max_bldsugr_time]);

  const min_time = React.useMemo(() => {
    const time = (min_bldsugr_time || '').split('');
    time.splice(2, 0, ':');
    return time.join('');
  }, [min_bldsugr_time]);

  return (
    <table>
      <tbody>
        <tr>
          <th>
            <div>
              {T('평균혈당')}
            </div>
          </th>
          <td>
            <div {...ex(['BASE_COLOR', CHECK_COLORS('B', avg_bldsugr)])}>
              {T('{0} mg/dL', avg_bldsugr)}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('최고혈당')}
            </div>
          </th>
          <td>
            <div>
              <HBox>
                <div {...ex(['BASE_COLOR', CHECK_COLORS('B', max_bldsugr_val)])}>
                  {max_bldsugr_val}
                </div>
                &nbsp;
                <div>
                  {T('mg/dL ({0} - {1})', max_time, DAY_ZONE_TYPES[+max_bldsugr_tmzone_cd - 1])}
                </div>
              </HBox>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('최저혈당')}
            </div>
          </th>
          <td>
            <div>
              <HBox>
                <div {...ex(['BASE_COLOR', CHECK_COLORS('B', min_bldsugr_val)])}>
                  {min_bldsugr_val}
                </div>
                &nbsp;
                <div>
                  {T('mg/dL ({0} - {1})', min_time, DAY_ZONE_TYPES[+min_bldsugr_tmzone_cd - 1])}
                </div>
              </HBox>
            </div>
          </td>
        </tr>
        {/* <tr>
          <th>
            <div>
              {T('일 최고 혈당상승폭')}
            </div>
          </th>
          <td>
            <div>
              {T('{0}{1} mg/dL', max_bldsugr_rise_w === 0 ? '' : Math.sign(max_bldsugr_rise_w) < 0 ? '-' : '+', max_bldsugr_rise_w)}
            </div>
          </td>
        </tr> */}

        {/* <tr>
          <th>
            <div>
              {T('식후 2시간 평균혈당')}
            </div>
          </th>
          <td>
            <div>
              <HBox>
                <div {...ex(['BASE_COLOR', CHECK_COLORS('B', postprand2h_bldsugr_val)])}>
                  {postprand2h_bldsugr_val}
                </div>
                &nbsp;
                <div>
                  {T('mg/dL (식후 2시간)')}
                </div>
              </HBox>
            </div>
          </td>
        </tr> */}
        <tr>
          <th>
            <div>
              {T('이상혈당')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} 건 (고혈당 {1} 건, 저혈당 {2} 건)', total_abnormal_cnt, total_high_cnt, total_low_cnt)}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
